import React from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonModal,
  IonIcon,
  IonContent,
  IonButtons,
  IonToolbar,
  IonList,
  IonText,
} from '@ionic/react';
import { close, alertCircleOutline } from 'ionicons/icons';

function SplitWarningModal({ open, onClose }) {
  return (
    <IonModal isOpen={open} onDidDismiss={onClose} cssClass="warning-modal">
      <IonToolbar mode="ios">
        <IonButtons slot="end">
          <IonButton onClick={onClose}>
            <IonIcon color="tertiary" slot="icon-only" icon={close} />
          </IonButton>
        </IonButtons>
      </IonToolbar>
      <IonContent>
        <IonList className="ion-padding">
          <IonText className="center-flex-content mt-3x mb-5x">
            <IonIcon
              color="danger"
              className="large-icon"
              icon={alertCircleOutline}
            />

            <h2 className="mt-3x">
              Tell your server you want to split your tab
            </h2>
            <p>
              Split tab hasn't been activated at your table yet. Once activated,
              you'll be prompted to select your items.
            </p>
          </IonText>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

SplitWarningModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SplitWarningModal;
